var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPodV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 3H4C3.17157 3 2.5 3.67157 2.5 4.5L2.5 13.5C2.5 14.3284 3.17157 15 4 15H12C12.8284 15 13.5 14.3284 13.5 13.5V4.5C13.5 3.67157 12.8284 3 12 3H10.5",
    stroke: "white",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.20834 2.88474C5.37795 2.71427 5.74322 2.35765 5.99348 2.2924C6.20477 2.2373 6.36759 2.09055 6.42838 1.8994C6.5935 1.37999 7.12265 1 7.74994 1C8.37726 1 8.90645 1.38002 9.07159 1.89945C9.13229 2.09037 9.29472 2.2373 9.50575 2.29219C9.75629 2.35739 10.0387 2.71414 10.2085 2.88474C10.2592 3.01455 10.5 3.34229 10.5 3.4878V3.5C10.5 3.77614 10.2761 4 10 4H5.5C5.22386 4 5 3.77614 5 3.5V3.47787C5.0012 3.33602 5.15878 3.04255 5.20834 2.91577",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72441 7.5H6.275C6.12312 7.5 6 7.62312 6 7.775C6 7.92687 6.12312 8.04999 6.275 8.04999H9.72441C9.87628 8.04999 9.9994 7.92687 9.9994 7.775C9.9994 7.62312 9.87628 7.5 9.72441 7.5Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72441 9.5H6.275C6.12312 9.5 6 9.62312 6 9.775C6 9.92687 6.12312 10.05 6.275 10.05H9.72441C9.87628 10.05 9.9994 9.92687 9.9994 9.775C9.9994 9.62312 9.87628 9.5 9.72441 9.5Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodV2);
export default __webpack_public_path__ + "static/media/podV2.454af64f11d8214b48d69c7b9d599ec7.svg";
export { ForwardRef as ReactComponent };